var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f;
import { makeAutoObservable } from "mobx";
import { inject } from "tsyringe";
import { perRestaurant } from "../di";
import { t, translate } from "../I18n";
import { LocalizationProvider } from "../locale";
import { DeliveryAddress, DeliveryAddressStatus, FulfillmentInstructions, FulfillmentInstructionsToken, } from "../ordering";
import { DialogStateManager } from "./DialogStateManager";
import { maxPriceForFreeDelivery } from "./MaxPriceForFreeDelivery";
import { PPurchaseOrder } from "./PPurchaseOrder";
let PFreeDeliveryWithAddressStickyAlert = class PFreeDeliveryWithAddressStickyAlert {
    constructor(deliveryAddress, dialogStateManager, fulfillmentInstructions, deliveryAddressStatus, purchaseOrder, localizationProvider) {
        this.deliveryAddress = deliveryAddress;
        this.dialogStateManager = dialogStateManager;
        this.fulfillmentInstructions = fulfillmentInstructions;
        this.deliveryAddressStatus = deliveryAddressStatus;
        this.purchaseOrder = purchaseOrder;
        this.localizationProvider = localizationProvider;
        makeAutoObservable(this);
    }
    get isDelivery() {
        if (this.fulfillmentInstructions.type === "Online") {
            return (this.fulfillmentInstructions.fulfillmentMethodType === "Delivery" ||
                this.fulfillmentInstructions.fulfillmentMethodType ===
                    "NoContactDelivery");
        }
        return false;
    }
    get isAddressFilledIn() {
        return !this.deliveryAddress.streetAddress.isEmpty;
    }
    get isSomethingInCart() {
        return this.purchaseOrder.orderLines.length > 0;
    }
    get deliveryThreshold() {
        if (this.deliveryAddressStatus.state.type === "RestaurantDelivers") {
            return this.deliveryAddressStatus.state.freeDeliveryThreshold;
        }
        else
            return null;
    }
    get isVisible() {
        return (this.dialogStateManager.state.freeDeliveryWithAddressStickyAlert ==
            true &&
            this.isAddressFilledIn &&
            this.deliveryThreshold !== null &&
            this.isDelivery &&
            !this.isSomethingInCart &&
            this.deliveryThreshold.roundUp().asNumber <=
                maxPriceForFreeDelivery(Skubacz.configuration.currency));
    }
    markAsClosed() {
        this.dialogStateManager.state.freeDeliveryWithAddressStickyAlert = false;
    }
    // Public only for analytics purposes
    get freeDeliveryPrice() {
        var _a, _b;
        return (_b = (_a = this.deliveryThreshold) === null || _a === void 0 ? void 0 : _a.roundUp()) !== null && _b !== void 0 ? _b : null;
    }
    get textMessage() {
        return this.freeDeliveryPrice !== null
            ? translate(t.client.labels.free_delivery_with_address, {
                amount: this.localizationProvider.formatPriceWithoutCents(this.freeDeliveryPrice),
            })
            : null;
    }
};
PFreeDeliveryWithAddressStickyAlert = __decorate([
    perRestaurant(),
    __param(2, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof DeliveryAddress !== "undefined" && DeliveryAddress) === "function" ? _a : Object, typeof (_b = typeof DialogStateManager !== "undefined" && DialogStateManager) === "function" ? _b : Object, typeof (_c = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _c : Object, typeof (_d = typeof DeliveryAddressStatus !== "undefined" && DeliveryAddressStatus) === "function" ? _d : Object, typeof (_e = typeof PPurchaseOrder !== "undefined" && PPurchaseOrder) === "function" ? _e : Object, typeof (_f = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _f : Object])
], PFreeDeliveryWithAddressStickyAlert);
export { PFreeDeliveryWithAddressStickyAlert };
